import capitalizeString from './capitalizeString';
var trimSpaces = function (str) { return str.replace(/\s+/g, ' ').trim(); };
var capitalizeName = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    if (!(firstName && lastName)) {
        return '';
    }
    var trimmedFirstName = trimSpaces(firstName);
    var trimmedLastName = trimSpaces(lastName);
    var beginningOfFirstNameIsCapitalized = trimmedFirstName[0] &&
        trimmedFirstName[0].toUpperCase() === trimmedFirstName[0] &&
        trimmedFirstName[1] &&
        trimmedFirstName[1].toLowerCase() === trimmedFirstName[1];
    var beginningOfLastNameIsCapitalized = trimmedLastName[0] &&
        trimmedLastName[0].toUpperCase() === trimmedLastName[0] &&
        trimmedLastName[1] &&
        trimmedLastName[1].toLowerCase() === trimmedLastName[1];
    var _b = trimmedLastName.split(' '), lastNameWithoutFirstWord = _b.slice(1);
    var middleOfLastNameIsCapitalized = lastNameWithoutFirstWord.some(function (word) {
        return word[0] &&
            word[0].toLocaleUpperCase() === word[0] &&
            word[1] &&
            word[1].toLocaleLowerCase() === word[1];
    });
    var returnedFirstName = beginningOfFirstNameIsCapitalized
        ? trimmedFirstName
        : capitalizeString(trimmedFirstName.toLowerCase());
    var returnedLastName = beginningOfLastNameIsCapitalized || middleOfLastNameIsCapitalized
        ? trimmedLastName
        : capitalizeString(trimmedLastName.toLowerCase());
    return returnedFirstName + " " + returnedLastName;
};
export default capitalizeName;
